module.exports = __webpack_public_path__ + "img/u99.70570165.png";